import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./PaymentReminderPopup.module.css";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { useEffect } from "react";
import { firebaseConfig } from "../../../../Firebase";
import { useSelector } from "react-redux";
import CustomButton from "../../../../components/custom/CustomButton";
import { isAdmin } from "../../../../utills/utils";
import { trackEvent } from "../../../../analytics";

export default function PaymentReminderPopup() {
  const [reportData, setReportData] = useState(null);
  const { selectedHotel } = useSelector((state) => state.hotels);

  const location = useLocation();

  useEffect(() => {
    if (isAdmin()) return;
    const app = initializeApp(firebaseConfig);
    const firestore = getFirestore(app);
    const paymentDoc = async (hotelId) => {
      const paymentCollection = collection(firestore, "paymentCollection");
      const q = query(paymentCollection, where("hotelId", "==", hotelId));
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        setReportData(doc.data());
      });
    };
    if (selectedHotel?.id) {
      try {
        paymentDoc(`${selectedHotel?.id}`);
      } catch {}
    }
  }, [selectedHotel?.id, location.pathname]);

  const handlePayNow = () => {
    window.open(reportData.paymentLink, "_blank");
    trackEvent("payment-reminder-popup-pay-now-click");
  };

  const handleCloseButton = () => {
    setReportData(null);
    trackEvent("payment-reminder-popup-closed");
  };

  useEffect(() => {
    trackEvent("payment-reminder-popup");
  }, []);

  useEffect(() => {
    if (reportData?.isActive) {
      trackEvent("paymet-reminder-popup-opened");
    }
  }, [reportData?.isActive]);

  return reportData?.isActive ? (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {!reportData.isForcePayment ? (
          <div className={styles["close-button"]} onClick={handleCloseButton}>
            X
          </div>
        ) : null}
        <img
          src="https://ik.imagekit.io/hotelzifyprod/6802f3a6-87dd-49e6-a3fb-c8797d7d26c2.png"
          alt="icon"
          className={styles["report-image"]}
        />
        <div className={styles.title}>{reportData.header}</div>
        <div className={styles.description}>{reportData.body}</div>
        <a href={reportData.csvLinkFile} className={styles["download-button"]}>
          Download Booking Report
        </a>
        <CustomButton
          onClick={handlePayNow}
          style={{ width: "100%" }}
          buttonStyle={{ width: "100%", color: "white", padding: "10px" }}
          color="#70cf2f"
        >
          Pay Now
        </CustomButton>
      </div>
    </div>
  ) : null;
}
